'use client';

import React, { useEffect, useState } from 'react';
import { Link } from 'wouter';
import Logo from '../../assets/images/Vyzle-Logo-Light-Mode.png';

const Header = () => {
  const [sticky, setSticky] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = (): void => {
      const heroSection = document.querySelector('.hero-sec') as HTMLElement | null;

      if (heroSection) {
        const heroHeight = heroSection.offsetHeight;
        const scrollY = window.scrollY;

        setSticky(scrollY >= heroHeight / 1.5);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`w-full  lg:px-16 md:px-12 sm:px-8 px-4 py-2 flex justify-center z-50 transition-all duration-500 ease-in-out ${
        sticky
          ? 'fixed top-0 left-0 bg-white shadow-md translate-y-0 opacity-100'
          : 'absolute top-0 left-0 bg-[#fefefe] translate-y-0 opacity-100'
      }`}
    >
      <nav className="w-full max-w-[1920px] mx-auto flex items-center justify-between">
        <div>
          <img
            src={Logo}
            alt="Logo"
            className="md:h-12 sm:h-12 h-10 transition-all duration-300"
          />
        </div>
<div className='flex justify-center items-center gap-4'>
        <div className="flex sm:gap-6 gap-3 items-center">
          <Link
            to="/app"
            className="sm:px-5 px-3 py-2 text-[#64748B] rounded-lg md:text-[15px] sm:text-sm text-[12px] font-primary font-semibold hover:border-2 hover:border-green hover:shadow-[4px_4px_0px_0px_#0F172A] transition duration-300"
          >
            Log In
          </Link>

          <Link
            to="/app/welcome"
            className="bg-[#059669] sm:px-5 px-3 py-2.5 text-[#F8FAFC] rounded-lg md:text-[15px] sm:text-sm text-[12px] font-primary font-semibold shadow-[4px_4px_0px_0px_#0F172A] hover:scale-105 transition duration-300"
          >
            Get Started
          </Link>
        </div>
        <div className='p-2 rounded-full bg-[#6A35E0] text-white text-sm'>Beta</div>
        </div>
      </nav>
    </header>
  );
};

export default Header;